/* eslint-disable */
import ls from 'local-storage';
import 'jquery.cookie';
import 'jcarousel';

import gaAsync from '@/js/common/Domain/Service/gaAsync';
import searchSessionService from '@/js/common/Domain/Service/search/searchSession';
import mindBoxService from '@/js/common/Service/mindBoxService/MindBoxServiceDesktop';
import trackingService from '@/js/common/Domain/Service/tracking/tracking';
import imageProxy from '@/js/common/Domain/Service/imageProxy';
import toRouterHotelHydrator from '@/js/common/Domain/Hydrator/toRouterHotel';

import hotelTemplate from './searchPageHotel/hotelTemplate.html';
import '@/js/desktop/View/searchPageHotel/serpHotelCard/serpHotelCard.scss';
import '@/js/common/components/reviewsColor/reviewsColor.scss';
import '@/css/desktop/tooltip.scss';
import componentsBannerTemplate from '@view/desktop/layout/parts/search/search__tour-usually-includes-js.phtml';
import adBannerTemplate from '@view/common/components/search/search__ad-banner.phtml';
import '@/js/desktop/components/search/useFilters/styles/useFilters.css';
import '@/js/desktop/components/search/useFilters/styles/useFiltersBnr.scss';
import filterBannerTemplate from '@/js/desktop/components/search/useFilters/search__use-filters-banner-js.phtml';
import LotteryBanner from '@/js/desktop/components/search/lotteryBannerSerp/LotteryBanner';
import checkLotteryService from '@/js/common/Domain/Service/checkLottery';
import partialPaymentService from '@/js/common/Domain/Service/partialPayment';
import getShowcasePath from '@/js/common/Domain/Service/getShowcasePath';

import CashbackHotelCardBannerView from '@/js/desktop/components/cashbackHotelCardBanner/cashbackHotelCardBanner';
import CashbackPartialPaymentTourBannerView from '@/js/desktop/components/partialPayment/cashbackPartialPaymentTourBanner/cashbackPartialPaymentTourBanner';
import PartialPaymentTourBannerView from '@/js/desktop/components/partialPayment/partialPaymentTourBanner/partialPaymentTourBanner';

import checkTourCashbackAvailable from '@/js/common/Domain/Service/checkTourCashbackAvailable';

import TooltipPopoverHtml from '@/js/common/components/tooltip/htmlTooltip/HtmlTooltip';
import '@/css/common/components/warranted-icon.scss';
import getStore from '@ve/services/getStore/getStore';
import Vue from 'vue';
import SearchPageHotelCardRightBlock from '@ve/components/serpHotelCard/SearchPageHotelCardRightBlock.vue';
import preparePropsForHotelCardRightBlock from '@ve/components/serpHotelCard/services/preparePropsForHotelCardRightBlock';
import ExclusiveBlock from '@ve/components/ExclusiveBlock/ExclusiveBlock.vue';
import { getPromo, copyPromo, initCommonPromoTooltip, sendPromoClick, sendPromoView } from '@/js/common/services/promoService';
import getPageTypeService from "@/js/common/Domain/Service/getPageType";
import { DataLayerService } from "@/js/common/services/DataLayerService";
import { operators } from "@fr/constants";
import { getToursConfirmationType } from '@entities/tourProduct';
import { ConfirmationTypeIcon } from '@entities/confirmationType';
import { OperatorFilterService, OPERATOR_FILTER_MAP } from "@/js/common/services/OperatorFilterService";
import trackImageErrors from "@/js/desktop/Domain/Service/trackImageErrors";

const shoucaseUrl = getShowcasePath();
const promo = getPromo();
const promoBanner = promo?.parts?.serpBanner;
const ExclusiveBlockConstructor = Vue.extend(ExclusiveBlock);
const sentPromoTitles = new Set();

const AD_BANNER_SELECTOR = '.ad-banner';

let SearchPageHotelViewModel = Backbone.Epoxy.Model.extend({
	defaults: {
		hotelIndex: null,
		componentsOrder: null,
		regionType: null,
		regionWithOffices: null,
		searchPageModel: null,
		hidePartialBanner: false
	},
	computeds: {
		filterBanner: {
			deps: ['hotelIndex', 'componentsOrder'],
			get: function (hotelIndex, componentsOrder) {
				return this.checkBannerPosition(hotelIndex, componentsOrder, 'filterBanner') ? filterBannerTemplate({hotelIndex}) : '';
			}
		},
		lotteryBanner: {
			deps: ['hotelIndex', 'componentsOrder'],
			get: function (hotelIndex, componentsOrder) {
				var $lotteryBanner = '';

				if (this.checkBannerPosition(hotelIndex, componentsOrder, 'lotteryBanner')) {
					$lotteryBanner = (new LotteryBanner()).$el;
				}

				return $lotteryBanner;
			}
		},
		componentsBanner: {
			deps: ['hotelIndex', 'componentsOrder'],
			get: function (hotelIndex, componentsOrder) {
				return this.checkBannerPosition(hotelIndex, componentsOrder, 'tourIncludes') ? componentsBannerTemplate({hotelIndex}) : '';
			}
		},
		adBanner: {
			deps: ['hotelIndex', 'componentsOrder'],
			get: function (hotelIndex, componentsOrder) {
				if (promoBanner?.active) {
					const buttonText = promo.coupon ? 'Скопировать промокод' : 'Понятно';
					const data = { buttonText, hotelIndex, ...promo, ...promoBanner };
					let adBanner = '';

					if (this.checkBannerPosition(hotelIndex, componentsOrder, 'adBanner')) {
						adBanner = adBannerTemplate(data);
					}

					return adBanner;
				}
			}
		},
	},
	checkBannerPosition: function (index, componentsOrder, componentName) {
		var step = 3,
			componentsLength = step * componentsOrder.length,
			elLength,
			componentsOrderElName;

		componentsOrderElName = componentsOrder[((index - 2) / step) % componentsOrder.length];
		if (_.isArray(componentsOrderElName)) {
			elLength = componentsOrderElName.length;
			var elIndex = parseInt((index / componentsLength)) % elLength;
			componentsOrderElName = componentsOrderElName[elIndex];
		}
		return componentsOrderElName === componentName;
	},
	initialize: function (options) {
		this.searchFormViewModel = options.searchFormViewModel;
	}
});

const SearchPageHotelView = Backbone.Epoxy.View.extend({
	el: '<div class="serpHotelCard"></div>',
	hotelTemplate,
	AD_BANNER_SELECTOR,
	data: null,
	template: null,
	events: {
		"click .goToHotelWithId": "goToHotelWithId",
		"click .serpHotelCard__container": "setInCookieMinPrice",
		"click .goToHotel": "goToHotel",
		"mousedown .serpHotelCard__container a:not(.goto-ua-page, .notChange)": 'hotelClick',
		'click .banner-close': 'closeBanner',
		"click .ad-banner__button": "handleBannerButtonClick",
		"click .ad-banner__link": "handleBannerLinkClick",
	},
	handleBannerLinkClick(e) {
		const target = e.currentTarget;
		const behaviour = target.dataset.behaviour;
		const banner = target.closest(AD_BANNER_SELECTOR);

		sendPromoClick(
			banner,
			behaviour,
			'link'
		)

		if (behaviour === 'copy') {
			e.preventDefault();
			copyPromo(target);
		} else if (behaviour === 'openThisPage') {
			e.preventDefault();
			window.location.href = target.href;
		}
	},
	handleBannerButtonClick(e) {
		const target = e.currentTarget;
		const behaviour = target.dataset.behaviour;
		const banner = target.closest(AD_BANNER_SELECTOR);

		sendPromoClick(
			banner,
			behaviour,
			'button'
		);

		switch (behaviour) {
			case 'copy':
				target.setAttribute('data-coupon', target.dataset.value);
				copyPromo(target);
				initCommonPromoTooltip(target);
				break;
			case 'close':
				$(banner).remove();
				break;
			case 'openNewPage':
				window.open(target.dataset.value, '_blank');
				break;
			case 'openThisPage':
				window.open(target.dataset.value, '_self');
				break;
		}
	},
	closeBanner(e) {
		const currentTarget = e.currentTarget;
		const bannerElement = currentTarget.closest(AD_BANNER_SELECTOR);
		const bannerName = $(currentTarget).data('banner');
		const bannerPosition = $(currentTarget).data('index') + 1;
		const parent = currentTarget.parentElement;

		if (!parent) return;

		if (bannerElement) {
			const promoData = {
				id: bannerElement.dataset.promoTitle,
				creative: bannerElement.dataset.promoCreative,
				position: getPageTypeService(),
				creative_slot: 'Close_cross'
			};
			DataLayerService.sendPromoClick(promoData);
		}

		window.dataLayer.push({
			event: 'selectContent',
			selectContent:
				{
					prop: [
						{type: 'engageBanner', value: bannerName}
					],
					prop2: [
						{type: 'position', value: bannerPosition}
					]
				}
		});

		$(parent).remove();
	},
	trackingHotelClick() {
		trackingService.trackSerpHotelPosition({
			hotels: this.collectionView.collection,
			selectedHotel: this.model,
			sortStrategy: this.collectionView.model.get('sortStrategy'),
		});
	},
    mindBoxTrackingHotelClick() {
        mindBoxService.trackViewSerpClick('serp_main', {
            searhPageModel: this.model,
            collectionViewModel: this.collectionView.model,
        });
    },

    hotelClick(e) {
		this.trackingHotelClick();
        this.mindBoxTrackingHotelClick();
        this.hrefUrl(e);
    },

	setInCookieMinPrice: function () {
		$.cookie("hotelMinPrice", this.model.get("priceWithOilTax"), {
			expires: 1 / 24 / 60 / 3,
			path: '/',
			domain: 'all'
		});
	},
	generateImagesHtml({ cover, photos }) {
		const images = [...new Set([cover, ...(photos || [])])];

		const imageItems = images.map(photo => `
			<li>
				<a href="#" 
					data-src="${this.proxiedImageUrl(photo)}" 
					data-original="${photo}"
					style="background-image: none">
				</a>
			</li>`).join('');

		const lastPhotoLink = images.length ? `
			<li class="lastPhotoLink">
				<a class="img" href="#" 
					data-src="${this.proxiedImageUrl(images[0])}"
					style="background-image: none">
				</a>
				<a href="#" class="btn">Смотреть все фото</a>
			</li>` : '';

		return imageItems + lastPhotoLink;
	},

	proxiedImageUrl(originalUrl) {
		return encodeURI(imageProxy(originalUrl, {
			width: 300,
			height: 220
		}));
	},

	render() {
		const data = this.model.toJSON({computed: true});
		const hotelIndex = this.collectionView.collection.indexOf(this.model);

		this.viewModel.set({
			hotelIndex: hotelIndex,
			searchPageModel: this.collectionView.model
		});

		if (this.hotelMapView) {
			this.hotelMapView.reRender({
				data,
				$el: this.$el,
				parentModel: this.model,
				collectionView: this.collectionView,
			});
		} else {
			this.$el.html(this.hotelTemplate(data));
		}

		setTimeout(() => {
			this.initCarousel();
			this.initSubscribes();
			this.buildPhotos();
			this.initSubViews();
			this.initVueComponents();
			this.showBottomBanner();
		}, 0);

		this.data = data;
		return this;
	},

	initCarousel() {
		const $carousel = $('.js-images-carousel', this.$el);

		if ($carousel.data('jcarousel')) {
			$carousel.jcarousel('destroy');
		}

		$carousel.jcarousel({
			list: '.list',
			items: 'li',
			wrap: 'both',
			vertical: false,
			animation: 'fast'
		});

		$('.js-images-carousel-control-prev', this.$el).jcarouselControl({
			target: '-=1'
		});

		$('.js-images-carousel-control-next', this.$el).jcarouselControl({
			target: '+=1'
		});
	},

	buildPhotos() {
		const imagesHtml = this.generateImagesHtml({
			cover: this.model.get('cover'),
			photos: this.model.get('photos')
		});

		if (imagesHtml) {
			this.model.set('imagesHtml', imagesHtml);
			this.renderPhotos();
		}
	},

	renderPhotos() {
		const $carousel = $('.js-images-carousel', this.$el);
		const $imagesPlace = $('.imagesHtml', $carousel);
		const imagesHtml = this.model.get('imagesHtml');

		if (imagesHtml && $imagesPlace.length) {
			$imagesPlace.html(imagesHtml);

			if ($carousel.data('jcarousel')) {
				$carousel.jcarousel('reload', {
					animation: 'fast'
				});
				$carousel.jcarousel('scroll', 0, false);
			}

			$carousel.find('li:visible a:not(.btn)').each((_, element) => {
				this.loadImageWithFallback($(element));
			});
		}
	},

	loadImageWithFallback($element) {
		try {
			const img = new Image();
			const src = $element.data('src');

			if (!src) return;

			img.onload = () => {
				requestAnimationFrame(() => {
					$element.css('background-image', `url("${src}")`);
				});
			};

			img.onerror = () => {
				trackImageErrors(src);
			};

			img.src = src;
		} catch (e) {
			console.error('Image load error:', e);
		}
	},

	isHotelHotView() {
		return false;
	},
	getPropsForHotelCardRightBlock() {
		const { models } = this.model.get('tourProducts');
		const segmentId = models
			?.map(model => model.get('tour')?.get('promoSegmentId'))
			?.find(Boolean);

		const tourProduct = this.model.get('tourProducts').at(0);
		const tour = tourProduct.get('tour');
		tour.set('promoSegmentId', segmentId);

		return preparePropsForHotelCardRightBlock({
			product: tour,
			productPrice: tour.get('priceWithOilTax'),
			productType: 'tourOffer',
		});
	},
	getTourCriteria(identity) {
		const operatorFilterIds = this.collectionView.model.get('filterCriteria')?.get('operators') || [];
		const tourProduct = identity
			? this.model.get('tourProducts').findWhere({ id: identity })
			: this.model.get('tourProducts').at(0);

		const clonedTourCriteria = tourProduct.get('tourCriteria').clone();
		const filterType = window.appConfig.hotelPageOperatorFilter || OPERATOR_FILTER_MAP.THROUGH;

		if (filterType === OPERATOR_FILTER_MAP.DROP) {
			return clonedTourCriteria;
		}

		const allHotelOperators = this.model.get('tourProducts').map(
			product => product.get('tour')?.get('operator')
		).filter(Boolean);

		const filteredOperators = OperatorFilterService.filterOperators({
			allHotelOperators,
			operatorFilterIds,
			filterType,
			travelataId: operators.MY_AGENT[0]
		});

		if (filteredOperators.length) {
			clonedTourCriteria.set('operators', new Backbone.Collection(filteredOperators));
		}

		return clonedTourCriteria;
	},
	initSerpHotelCardRightBlock() {
		const store = getStore();
		const hotelCardRightBlockData = this.getPropsForHotelCardRightBlock();
		return new Vue({
			render: (h) => h(SearchPageHotelCardRightBlock, {
				props: {
					hotelCardRightBlockData,
				},
				on: {
					'go-to-target-page-button-click': (e) => {
						if (this.isHotelHotView()) this.goToTourPage(e);
						else this.goToHotel(e);
					},
				},
			}),
			store,
		}).$mount(this.el.querySelector('.js-right-block'));
	},
	initIsExclusiveBlock() {
		const isExclusive = this.model.get('isExclusive');
		if (isExclusive) {
			this.$el.addClass('isExclusive');
			const element = this.$('.js-serpHotelCard__isExclusive', this.$el).get(0);

			this.exclusiveBlockInstance = new ExclusiveBlockConstructor({
			}).$mount(element);
		}
	},
	initConfirmation() {
		new Vue({
			render: (h) => h(ConfirmationTypeIcon, {
				props: {
					type: this.getToursConfirmationType(),
				},
			}),
		}).$mount(this.el.querySelector('.js-confirmation-icon'));

    },
	initVueComponents() {
		this.initSerpHotelCardRightBlock();
		this.initIsExclusiveBlock();
		this.initConfirmation();
	},
	selectTemplate: function () {
		return this.template;
	},
	componentsList: function () {
		let componentsOrder = [
			'adBanner',
			'filterBanner',
			'tourIncludes',
		];

		componentsOrder = promoBanner?.active ? componentsOrder : _.without(componentsOrder, 'adBanner');

		return componentsOrder;
	},
	showBottomBanner() {
		const { isVisible: isVisiblePartialPayment } = this.getPartialPaymentData();
		const hasTourCashbackAvailable = checkTourCashbackAvailable(this.model.get('tourProducts'));

        const isCashbackAvailable = window?.appConfig?.cashbackAvailable
            && hasTourCashbackAvailable;

        if (isCashbackAvailable) {
            if (isVisiblePartialPayment) {
                this.initCashbackPartialPaymentBanner();
                return;
            }

            this.initCashbackBanner();
            return;
        }

        if (isVisiblePartialPayment) {
            this.initPartialPaymentBanner();
        }
    },


	getToursConfirmationType() {
        const tourProducts = this.model.get('tourProducts')?.models.map((tourProduct) => tourProduct.get('tour').attributes);
        const confirmationType = getToursConfirmationType(tourProducts || []);

        return confirmationType;
    },

    getPartialPaymentData() {
        const tourProducts = this.model.get('tourProducts');
        const tourProduct = tourProducts?.at(0);

        const isVisible = !!tourProduct.get('firstPaymentDefinition')?.id;
        const countryName = this.model.get('country').get('name');

        return {
            isVisible,
            countryName,
            tourProducts,
        };
    },

    initPartialPaymentBanner() {
        const { countryName, tourProducts } = this.getPartialPaymentData();
        this.$el.addClass('partialPayment');

        new PartialPaymentTourBannerView({
            el: this.$el.find('.partialPayment__banner'),
            countryName,
            tourProducts,
        });
    },

    initCashbackPartialPaymentBanner() {
        const { countryName, tourProducts } = this.getPartialPaymentData();
        this.$el.addClass('cashbackPartialPayment');

        new CashbackPartialPaymentTourBannerView({
            el: this.$el.find('.cashbackPartialPayment__banner'),
            countryName,
            tourProducts,
        });
    },

    initCashbackBanner() {
        new CashbackHotelCardBannerView({
            el: $('.serpHotelCard__container', this.$el),
        });
    },

	initSubViews:function() {
		this.warrantyTooltip = new TooltipPopoverHtml({
			el: $('.js-warranted-icon', this.$el),
		});
	},
	reRender: function (model) {
		this.render();
	},
	initSubscribes: function () {
		var self = this;

		this.model.on('change:minPrice', $.proxy(this.reRender, this));
		this.model.on('change:tourProducts', $.proxy(this.reRender, this));
		this.model.on('change:photos', $.proxy(this.buildPhotos, this));


		if (this.collectionView) {

			this.collectionView.model.on('change:regionType', function (model, value) {
				self.viewModel.set('regionType', value);
			});
			this.collectionView.model.on('change:regionWithOffices', function (model, value) {
				self.viewModel.set('regionWithOffices', value);
			});
		}
	},
	searchFormViewModel: null,
	getComponentsData: function() {
		const self = this;
		const countries = this.viewModel.get('searchPageModel').get('searchData').get('countries');

		checkLotteryService(function() {
			self.viewModel.set('componentsOrder', self.componentsList());
		});
		if (countries.length === 1) {
			partialPaymentService.getByCountry({
				countryId: countries.at(0).get('id'),
				callback: function (data) {
					if (data) {
						self.viewModel.set('componentsOrder', self.componentsList());
					}
				}
			})
		}
	},
	initPromoViewObserver() {
		if (this.promoObserverInstance) {
			this.promoObserverInstance.disconnect();
		}

		this.promoObserverInstance = new MutationObserver((mutations) => {
			mutations.forEach(mutation => {
				mutation.addedNodes.forEach(node => {
					if (node.nodeType === 1 && node.matches(`${AD_BANNER_SELECTOR}[data-promo-creative="SerpBanner"]`)) {
						const promoTitle = node.dataset.promoTitle;
						if (promoTitle && !sentPromoTitles.has(promoTitle)) {
							sendPromoView(node);
							sentPromoTitles.add(promoTitle);
						}
					}
				});
			});
		});

		const targetNode = document.getElementById('hotelTemplate');
		if (targetNode) {
			this.promoObserverInstance.observe(targetNode, {
				childList: true,
				subtree: true
			});
		}
	},
	initialize: function(options) {
		const self = this;

		this.viewModel = new SearchPageHotelViewModel({
			hotelIndex: -1,
			componentsOrder: this.componentsList(),
			regionType: options.collectionView?.model.get('regionType') || 'default',
			regionWithOffices: options.collectionView?.model.get('regionWithOffices') || false,
			searchPageModel: options.collectionView?.model,
			searchFormViewModel: options.searchFormViewModel
		});

		this.collectionView = options.collectionView;
		this.dataLayerAnalytics = options.collectionView?.dataLayerAnalytics;
		this.template = options.template ? options.template : this.hotelTemplate;
		this.hotelMapView = options.hotelMapView;
		this.model.$element = this.$el;

		this.render();
		this.getComponentsData();
		this.initPromoViewObserver();
		this.bindImageErrorHandlers();
	},
	bindImageErrorHandlers() {
		this.$el.off('error', 'a[data-src]');
	},

	destroy: function() {
		const startSearchEl = document.getElementById('startSearch');
		if (startSearchEl && this.handleStartSearchClick) {
			startSearchEl.removeEventListener('click', this.handleStartSearchClick);
		}

		if (this.promoObserverInstance) {
			this.promoObserverInstance.disconnect();
			this.promoObserverInstance = null;
		}
	},
	hrefUrl: function (event) {
		var identity = $(event.currentTarget).data('identity'),
			urlParams = toRouterHotelHydrator({
				tourCriteria: this.getTourCriteria(),
				similar: this.model.get('similar') ? true : false
			}),
			hotelUrl = shoucaseUrl + '/hotel/' + this.model.get('id'),//this.model.get('url'),
			target = ($('.oneColumn:visible').length) ? '_self' : '_blank',
			$target = $(event.currentTarget);


		if (typeof identity !== 'undefined') {
			urlParams['identity'] = identity;
			if (event.which == 2) {
				gaAsync(function () {
					ga('send', 'event', 'Hotel_Card', 'Visit_the_hotel', 'date_price', {'nonInteraction': 1})
				});
			}
		} else {
			if (event.which == 2 && $target.parent().parent().parent().hasClass('serpHotel_Image')) {
				gaAsync(function () {
					ga('send', 'event', 'Hotel_Card', 'Visit_the_hotel', 'image_hotel', {'nonInteraction': 1})
				});
			}
		}
		if ($target.hasClass('distance')) {
			urlParams['toMap'] = true;
		}
		urlParams.sid = searchSessionService.getSearchId();
		$(event.currentTarget).attr('href', hotelUrl + '#?' + $.param(urlParams));
		$(event.currentTarget).attr('target', target);
		ls.set('isAbsent', false);
	},
	goToHotelWithId: function (event, param2, param3) {
		var identity = $(event.currentTarget).data('identity'),
			tourProduct = this.model.get('tourProducts').findWhere({id: identity}),
			tourCriteria = typeof (tourProduct) == 'undefined' ? null : tourProduct.get('tourCriteria');

		if (tourCriteria !== null) {
			var urlParams = toRouterHotelHydrator({
					tourCriteria: this.getTourCriteria(identity),
					identity: identity,
					similar: this.model.get('similar') ? true : false
				}),
				target = ($('.oneColumn:visible').length) ? '_self' : '_blank',
				hotelUrl =  `${shoucaseUrl}/hotel/${this.model.get('id')}`;

			urlParams.sid = searchSessionService.getSearchId();
			window.open(hotelUrl + '#?' + $.param(urlParams), target);
			ls.set('isAbsent', false);
		}
		return false;
	},
	goToHotel: function (event) {
		var urlParams = toRouterHotelHydrator({
				tourCriteria: this.getTourCriteria(),
				similar: this.model.get('similar') ? true : false
			}),
			$target = $(event.currentTarget),
			target = ($('.oneColumn:visible').length) ? '_self' : '_blank',
			hotelUrl =  `${shoucaseUrl}/hotel/${this.model.get('id')}`;

		if ($target.hasClass('distance')) {
			urlParams['toMap'] = true;
		}
		if ($target.hasClass('hotel-reviews')) {
			urlParams['toReviews'] = true;
		}
		urlParams.sid = searchSessionService.getSearchId();

		window.open(hotelUrl + '#?' + $.param(urlParams), target);
		ls.set('isAbsent', false);

		return false;
	},
	offerClick: function () {
	}
});

export default SearchPageHotelView;
